import { Component, Input, OnInit } from '@angular/core';
//import { Router } from '@angular/router';
import { BreadCrumb } from 'src/app/models/common/bread-crumb';
import { PageHeader } from 'src/app/models/common/page-header';
import { BaseSearchComponent } from 'src/app/system-common/base-search/base-search.component';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { SearchResponseIO } from 'src/app/models/search-responseIO';
import { BaseService } from 'src/app/system-common/services/base.service';
import { ProductionService } from '../services/production.service';

@Component({
  selector: '',
  template: '',
})
export class ProductionDetailsSearchHandler extends BaseSearchComponent<ProductionService> implements OnInit {
  public searchName: string;
  public fullPath;
  isAdvanceSearchDisplayed: boolean;
  searchCriteriaData: any;

  constructor(
    public service: ProductionService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService,
    public route: ActivatedRoute
  ) {
    super(service, router, headerService);
    this.addLink = '/search-production-details';
    //this.service.isAuditButtonClicked = false;
    // this.isSearchFilteredByCriteria = true;
    const pathSegments = this.route.snapshot.url;
    this.fullPath = pathSegments.map((segment) => segment.path).join('/');
  }

  ngOnInit() {
    super.ngOnInit();
    if (this.fullPath.includes('search-production-details/')) {
      this.searchName = 'SearchTeamProductionDetails';
    } else {
      this.searchName = 'SearchProductionDetails';
    }

    //const data = this.route.snapshot.queryParams['data'];
    let agentId = this.route.snapshot.paramMap.get('agentId');
    //const data = history.state[ 'data' ];
    if (agentId != undefined && agentId != null)
      this.searchCriteriaData = { 'ProductionDetailDO.sourceAgentId': agentId };

    if (
      this.settingService.getSessionStorageValue('AgentProduction') != undefined &&
      this.settingService.getSessionStorageValue('AgentProduction') != null
    ) {
      this.searchCriteriaData = {
        'ProductionDetailDO.productionName': this.settingService.getSessionStorageValue('AgentProduction'),
      };
      this.settingService.removeSessionStorage('AgentProduction');
    }
    // if (
    //   this.settingService.getSessionStorageValue('AgentProduction') != undefined &&
    //   this.settingService.getSessionStorageValue('AgentProduction') != null
    // ) {
    //   this.searchCriteriaData = {
    //     'ProductionDetailDO.productCd': this.settingService.getSessionStorageValue('AgentProduction'),
    //   };
    //   this.settingService.removeSessionStorage('AgentProduction');
    // }

    //this.service.forAuditSearchList = false;
    //this.settingService.removeSessionStorage('AuditChanges');
    this.isAdvanceSearchDisplayed = true;
  }

  protected getBreadCrumbList(): BreadCrumb[] {
    return [
      {
        id: 'Home',
        link: '/home',
      },
      {
        id: 'ProductionDetails',
        link: '/search-production-details',
      },
    ];
  }

  protected getMoreOptionList(): any[] {
    return [
      {
        id: 'Edit',
        link: '/search-production-details',
      },
      {
        id: 'Delete',
        link: '/search-production-details',
      },
      {
        id: 'Audit',
        link: '/search-production-details',
      },
      {
        id: 'Close',
        link: '/search-production-details',
      },
    ];
  }

  protected getPageHeader(): PageHeader {
    let header = new PageHeader();
    // header.title = 'Production Details';
    header.title = this.settingService.getLabelValue('ProductionDetails');
    return header;
  }

  Edit_click(optionDetails: { button_id; link; ref_id }) {
    let link: string;
    link = optionDetails.link.toString().replace(':id', optionDetails.ref_id);
    this.router.navigate([link]);
  }

  Audit_click(buttonClicked: { button_id: string; link: string; ref_id }) {
    this.service.id = buttonClicked.ref_id;
    setTimeout(() => {
      //this.service.isAuditButtonClicked = true;
    }, 10);
  }
}
